import $ from 'jquery';
import React from "react";
import _ from 'lodash';

import QuantityTextField from "./../quantityTextField";
import * as Misc from "./../../misc";
import ProjectScope from "./projectScope";
import StoneStore from "./../../stores/stonesStore";
import ActionTypes from "./../../actionTypes";
import IndividualFeatureItem from './individualFeatureItem';
import Analytics from './../../analytics';
import Config from "./../../config";
import StonesStore from '../../stores/stonesStore';
// import HelpIcon from "./helpIconView";

export default class StepMainView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getStateObject();
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteChanged);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteChanged);
  }

  handleQuoteChanged = () => {
    this.setState(this.getStateObject());
  };

  getStateObject = () => {
    const features = StoneStore.featuresByGroupName(this.props.groupName, ProjectScope.quote());
    const mainFeature = _.head(features);
    const selectedFeatures = ProjectScope.selectedFeatures();
    const selectedFeaturesFromGroup = _.intersectionWith(features, selectedFeatures, (feat, id) => {
      return id === feat.id;
    });
    const scopeFeatures = ProjectScope.quote().features;

    let hideQuantity = false;
    let individual = false;
    let hideUnit = false;

    if(mainFeature) {
      _.forEach(mainFeature.flags || [], f => {
        if (f === 'u') {
          hideUnit = true;
        } else if (f.substring(0, 1) === 'q') {
          hideQuantity = true;
        } else if (f === 'i') {
          individual = true;
        }
      });
    }

    if (individual) {
      hideQuantity = true;
      hideUnit = true;
    }

    let value = 0;
    if (!hideQuantity && mainFeature) {
      value = ProjectScope.quote().features[mainFeature.id];
    }

    return {
      value: value,
      features: features,
      mainFeature: mainFeature,
      selectedFeatures: selectedFeatures,
      selectedFeaturesFromGroup: selectedFeaturesFromGroup,
      scopeFeatures: scopeFeatures,
      hideQuantity: hideQuantity,
      individual: individual,
      hideUnit: hideUnit
    };
  };

  handleSelectClick = (e) => {
    Analytics.sendClickEvent('show-feature-selection: ' + this.props.groupName);
    Misc.ignoreDefault(e);
    Misc.hideQQGirl();
    this.props.showFeatureSelection(this.props.groupName);
  };

  handleValueChanged = (value) => {
    //this.setState({value: value});
    if (!this.state.hideQuantity) {
      const o = {};
      o[this.state.mainFeature.id] = value;
      ProjectScope.updateFeaturesQuantities([this.state.mainFeature.id], o);
      Analytics.sendDataEnteredEvent('selected-feature-changed: ' + this.props.groupName);
    }
  };

  goToNextView = (e) => {
    Analytics.sendClickEvent('feature-step-next-view');
    this.props.goToNextView(e);
  }

  renderQuantityBox = (hideQuantity) => {
    if (hideQuantity) {
      return null;
    }

    return (
      <QuantityTextField value={this.state.value} className="project-scope-textbox-form"
                         onBlur={this.handleValueChanged}/>
    );
  };

  render() {
    let innerFeaturesElements = null;
    let replaceInnerContainer = false;
    let elements = null;
    if (!this.state.individual) {
      if (/*this.state.hideQuantity &&*/ _.size(this.state.selectedFeaturesFromGroup)) {
        replaceInnerContainer = true;
        elements = _.take(this.state.selectedFeaturesFromGroup, Math.min(3, this.state.selectedFeaturesFromGroup.length))
          .map((f) => {
            return (<IndividualFeatureItem feature={f} scopeFeatures={this.state.scopeFeatures} key={f.id}/>);
          });

        while (elements.length < 3) {
          elements.push((<div className="project-scope-selection-options-placeholders" key={'ph' + elements.length}/>));
        }

        let others = null;
        if (this.state.selectedFeaturesFromGroup.length > 3) {
          others = (<h2>{"...and " + (this.state.selectedFeaturesFromGroup.length - 3) + " other(s)"}</h2>);
        }

        innerFeaturesElements = (
          <div className="project-scope-selection-options-wrapper">
            {elements}
            {others}
          </div>
        );

      }
    } else {
      if (_.size(this.state.selectedFeaturesFromGroup)) {
        replaceInnerContainer = true;
        elements = _.take(this.state.selectedFeaturesFromGroup, Math.min(3, this.state.selectedFeaturesFromGroup.length))
          .map((f) => {
            return (<IndividualFeatureItem feature={f} scopeFeatures={this.state.scopeFeatures} key={f.id}/>);
          });

        while (elements.length < 3) {
          elements.push((<div className="project-scope-selection-options-placeholders" key={'ph' + elements.length}/>));
        }

        let others = null;
        if (this.state.selectedFeaturesFromGroup.length > 3) {
          others = (<h2>{"...and " + (this.state.selectedFeaturesFromGroup.length - 3) + " other(s)"}</h2>);
        }

        innerFeaturesElements = (
          <div className="project-scope-selection-options-wrapper">
            {elements}
            {others}
          </div>
        );
      }
    }

    let fgm = StonesStore.getFeatureGroupMeta(this.props.groupName.trim());
    let groupName = this.props.groupName;
    let img = StoneStore.getFeatureGroupIconURL(this.props.groupName, true);
    let desc = Config.featureDescription(this.props.groupName);
    if(fgm) {
      if(fgm.customDisplayName && fgm.customDisplayName.length > 0) {
        groupName = fgm.customDisplayName;
      }
      if(fgm.customImageUrl && fgm.customImageUrl.length > 0) {
        img = `/content/Views/quickquote-v3/images/pj-scope-icons/enabled/${fgm.customImageUrl}`;
      }
      if(fgm.customDescription && fgm.customDescription.length > 0) {
        desc = fgm.customDescription;
      }
    }

    return (
      <div className="project-scope-main-body dragend-page" data-step={this.props.datastep}>
        <header className="project-scope-main-header">
          <div className="project-scope-main-header-cell">
            <div className="project-scope-main-header-logo" onClick={this.handleSelectClick}>
              <div className={"project-scope-main-header-logo-image project-scope-fading project-scope-main-header-logo-image--"
+ this.props.groupName.trim().toLowerCase().replace(" ", "-")}
  style={{backgroundImage: `url(${img})`}}
  />
              <div className="project-scope-main-header-logo-border"/>
              <div className="project-scope-main-header-logo-circle">
                <div className="project-scope-main-header-logo-circle-inner rotating"/>
              </div>
            </div>
          </div>
          <div className="project-scope-main-header-cell">
            <div className="project-scope-fading">
              {/*<HelpIcon title={this.props.groupName} todoType={this.props.groupName}/>*/}
              <div className="project-scope-main-header-title">STEP {this.props.datastep+1}</div>
              <h1 className="project-scope-main-header-subtitle">{groupName}</h1>
              <p className="project-scope-main-header-description"
                 dangerouslySetInnerHTML={{__html: desc}}/>
              {!innerFeaturesElements ? (<div className="project-scope-mobile-arrow"/>) : null}
            </div>
          </div>
        </header>
        <div className="project-scope-main-content">
          <div className="project-scope-fading">
            {innerFeaturesElements || null}
            <div className="project-scope-button project-scope-fading" onClick={this.handleSelectClick}>
              <span className="project-scope-button-text">{elements ? "Edit" : "Select"}</span>
            </div>
          </div>
        </div>
        <div className="project-scope-main-footer">
          <div className="project-scope-main-footer-cell project-scope-main-footer-cell--vis">
            <div className="footer-visualize" onClick={this.props.openKitchenVisualizerIframe}>
              <span className="footer-visualize-image"/>
              <span className="footer-visualize-text">Visualize My Kitchen</span>
            </div>
          </div>
          <div className="project-scope-main-footer-cell project-scope-main-footer-cell--buttons">
            <button className="project-scope-main-footer-button project-scope-main-footer-button--prev"
                    onClick={() => { this.props.changeStep(-1) }}>Back</button>
            {this.props.lastStep
              ? <button className="project-scope-main-footer-button project-scope-main-footer-button--next"
                        onClick={this.goToNextView}>Next</button>
              : <button className="project-scope-main-footer-button project-scope-main-footer-button--next"
                        onClick={() => { this.props.changeStep(+1) }}>
                {innerFeaturesElements ? "Next" : "Skip"}
              </button>
            }
          </div>
        </div>
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/projectScope/stepMainView.js